const doc = [({"en":({"js":({"components":({"plans":({"sign_up_modal":({"plan_card":({"start_subscription":"Start subscription"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;